import React, { useState } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { app } from '../firebase';
import { useToast } from '../components/ToastContext';
import { IoIosHelpCircle, IoIosHelpCircleOutline } from "react-icons/io";
import { VscArrowLeft } from "react-icons/vsc";
import './photo-change.css';

export default function Photochange() {
    const navigate = useNavigate();
    const location = useLocation();
    const [imageFile, setImageFile] = useState(null);
    const [imageURL, setImageURL] = useState(null);
    const storage = getStorage(app);
    const { showToast } = useToast(); // ✅ Use the toast context

  const handleGoBack = () => {
  if (window.history.length > 1) {
    navigate(-1); // Go back
  } else {
    navigate('/'); // No history, go to home
  }
};

    const handleChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImageFile(file);
            setImageURL(URL.createObjectURL(file));
        }
    };

    const submitData = async () => {
        if (!imageFile) {
            showToast("Please select an image first", "error");
            return;
        }

        try {
            const storageRef = ref(storage, `photos/${imageFile.name}`);
            await uploadBytes(storageRef, imageFile);
            const downloadURL = await getDownloadURL(storageRef);
            setImageURL(downloadURL);

            showToast("Upload successful!", "success");
        } catch (err) {
            console.error("Upload failed", err);
            showToast("Upload failed. Check console.", "error");
        }
    };

    return (
        <div className="container_roots">
            <div className="status-bar">
                <div className="container_size">
                    <div className="status-bar_size">
                        <div className="left_body">
                            <VscArrowLeft onClick={handleGoBack} className="back_arrow_btn" />
                        </div>
                        <div className="name-bar-body">Change Photo</div>
                        <div className="right_body">
                            <div
                                onClick={() => navigate('/help')}
                                className={`help-button-icon ${location.pathname === '/help' ? 'active' : ''}`}
                                title="Help Center"
                            >
                                {location.pathname === '/help' ? (
                                    <IoIosHelpCircle className="icon" />
                                ) : (
                                    <IoIosHelpCircleOutline className="icon" />
                                )}
                                <span className="button-text">Help</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="app_header_height"></div>

            <div className="container_size">
                <div className="post-container">
                    <div className="post_div">
                        <div className="photo-div">
                            {imageURL && <img className="photo-img" src={imageURL} alt="Preview" />}
                            <div>
                                <input type="file" onChange={handleChange} className="fileselect" />
                                <div className="button-ui" onClick={submitData}>Upload</div>
                            </div>
                        </div>
                    </div>

                    <div className="post_updates">
                        <div className="post_div">
                            <div className="message">
                                <p className="formal-info"><span>✅</span> Please provide your Wire account details...</p>
                                <p className="formal-info"><span>✨</span> By adding your account details...</p>
                                <p className="formal-info"><span>✨</span> Let the world see what you’ve got!</p>
                                <p className="formal-info">Sharing your Wire account makes it easier...</p>
                                <p className="formal-info"><span>💼</span> Complete your Wire account information...</p>
                                <p className="formal-info"><span>✨</span> A complete profile lets clients view...</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
